import { Skeleton } from '@common/components';

export function SearchPolicyCardSkeleton() {
  return (
    <div
      role="status"
      aria-label="정책 카드 로딩 중"
      className="flex flex-col gap-8 overflow-hidden rounded-medium border border-Gray-100 bg-Gray-white px-24 py-20 mobile-tablet:rounded-none mobile-tablet:border-x-0 mobile-tablet:border-b-0 mobile-tablet:border-t mobile-tablet:first:border-t-0"
    >
      <div className="flex h-48 items-start justify-between mobile-tablet:h-auto">
        <Skeleton className="h-24 w-3/4 rounded-xxsmall" />
        <Skeleton className="size-24 shrink-0 rounded-xxsmall mobile-tablet:hidden" />
      </div>
      <div className="rounded-small bg-Gray-25 p-12">
        <div className="flex flex-col gap-4">
          <Skeleton className="h-16 w-full rounded-xxsmall" />
          <Skeleton className="h-16 w-5/6 rounded-xxsmall" />
        </div>
      </div>
      <div className="flex items-center justify-between gap-12">
        <Skeleton className="h-16 w-160 rounded-xxsmall" />
        <Skeleton className="h-20 w-100 rounded-xxsmall" />
      </div>
    </div>
  );
}

interface SearchPolicyCardSkeletonListProps {
  count: number;
}

export function SearchPolicyCardSkeletonList({
  count,
}: SearchPolicyCardSkeletonListProps) {
  return (
    <ul
      aria-busy="true"
      className="flex flex-col gap-12 mobile-tablet:gap-0"
    >
      {Array.from({ length: count }, (_, index) => (
        <li key={index}>
          <SearchPolicyCardSkeleton />
        </li>
      ))}
    </ul>
  );
}
